import { render, staticRenderFns } from "./EnduserMyServices.vue?vue&type=template&id=3b2be3f2&"
import script from "./EnduserMyServices.vue?vue&type=script&lang=js&"
export * from "./EnduserMyServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports